import React, { memo } from 'react';
import { Row, Col, Typography, Skeleton, Image, Table } from 'antd';
import moment from 'moment';
import authStore from '../../store/authStore'

const { Text } = Typography;

interface Props {
    issueDetails?: any,
    imageList: any[],
    skeletonOn: boolean,
    imageCreatedBy: any[],
    imageNotes: any[]
}

const IssueTrackerDiagnosticCard: React.FC<Props> = memo(({ issueDetails, imageList, skeletonOn, imageCreatedBy }) => {

    const showLegacy = !!(issueDetails?.diagnosis || issueDetails?.overall_summary)
    const diagnosisNotes = Array.isArray(issueDetails?.diagnosis_notes) ? issueDetails.diagnosis_notes : []

    const noteColumns = [
        {
            title: 'Created Date',
            dataIndex: 'created_on',
            key: 'created_on',
            width: '22%',
            render: (ts: number) => (ts ? moment(ts).format('MM/DD/YYYY HH:mm:ss') : '—')
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (text: string) => <span style={{ whiteSpace: 'pre-wrap' }}>{text || '—'}</span>
        }
    ]

    return (
        <>
                <Row>
                    <Col span={24}>
                        <div className='W-100'>
                            <p style={{ fontSize: "16px", fontWeight: 500 }} className='mb-4'>
                                Diagnosis Details
                            </p>
                            <div className={imageList?.some((row) => row?.length) ? 'mb-4' : 'mb-2'}>
                            {!skeletonOn ?
                            (imageList?.length > 0 &&
                            imageList?.map((row, rowIndex) => (
                              row?.length > 0 &&
                                <div key={rowIndex} style={{ marginBottom: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div className="avatar" style={{ marginRight: 25, fontSize: 15 }}>
                                        {imageCreatedBy[rowIndex]?.createdBy ? (imageCreatedBy[rowIndex]?.createdBy?.charAt(0) + imageCreatedBy[rowIndex]?.createdBy?.slice(-1))?.toUpperCase() : 'U'}
                                    </div>
                                    <div>
                                        <p></p>
                                        <p style={{ fontSize: 12 }}>
                                        Uploaded on {moment(imageCreatedBy[rowIndex]?.createdAt).format("DD-MMMM-YYYY - HH:mm:ss") !==
                                            "Invalid Date"
                                            ?  moment(imageCreatedBy[rowIndex]?.createdAt).format("DD-MMMM-YYYY - HH:mm:ss")
                                            : "-"}
                                            {imageCreatedBy[rowIndex]?.createdBy && (imageCreatedBy[rowIndex]?.createdBy !== authStore.currentUser?.name) ? ` by ${imageCreatedBy[rowIndex]?.createdBy} ` : ''}
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 70 }}>
                                    {row?.map((image: any, colIndex: any) => (
                                    <div key={colIndex} style={{ marginRight: 10 }}>
                                        <Image src={image} style={{ height: 120, padding: 20 }} />
                                    </div>
                                    ))}
                                </div>
                                </div>
                            ))
                            )
                           :
                            <Col>
                            <Skeleton.Avatar active className="mr-3" />
                            <Skeleton.Input active style={{ width: 250, maxWidth: 250, minWidth: 200 }} className="mr-1 mb-1" />
                            <Skeleton.Input active style={{ width: 250, maxWidth: 250, minWidth: 200 }} />
                            </Col>
                            }
                            </div>
                            {showLegacy && (
                            <div className='p-1 mb-3' style={{ background: '#fafafa', borderRadius: 8 }}>
                            {issueDetails?.diagnosis ? (
                            <p className="paragraph mb-3">
                            <p style={{ fontSize: "13px", fontWeight: 5 }}>
                                Diagnosis
                            </p>
                                    <Text className="mr-1 mb-0">
                                        {issueDetails?.diagnosis}
                                    </Text>
                            </p>
                            ) : null}
                            {issueDetails?.overall_summary ? (
                            <p className="paragraph">
                            <p style={{ fontSize: "13px", fontWeight: 5 }}>
                                Overall Summary
                            </p>
                                    <Text className="mr-1 mb-0">
                                        {issueDetails?.overall_summary}
                                    </Text>
                            </p>
                            ) : null}
                            </div>
                            )}
                            <div className="p-1">
                                {/* <p style={{ fontSize: "13px", fontWeight: 600 }} className="mb-2">Diagnosis notes</p> */}
                                <Table
                                    columns={noteColumns as any}
                                    dataSource={diagnosisNotes.map((n: any) => ({ ...n, key: n.id }))}
                                    pagination={false}
                                    size="small"
                                    locale={{ emptyText: 'No diagnosis notes' }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>

        </>
    );
})
export default IssueTrackerDiagnosticCard;
